import { render, staticRenderFns } from "./CommunityCard.vue?vue&type=template&id=89fa3a4a&scoped=true&"
import script from "./CommunityCard.vue?vue&type=script&lang=js&"
export * from "./CommunityCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCard.vue?vue&type=style&index=0&id=89fa3a4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fa3a4a",
  null
  
)

export default component.exports